import React from 'react';
import classes from './BiomarkerItemSmall.module.css';
import {
  IDiagnoseReferenceRanges,
  IDiagnoseResult,
  IDigitalHealthProfile,
} from '../SelectedSalesOrder/DigitalHealthProfileTab';
import veryLowIcon from '../../../assets/icons/biomarkerRanges/very-low.svg';
import lowIcon from '../../../assets/icons/biomarkerRanges/low.svg';
import normalIcon from '../../../assets/icons/biomarkerRanges/normal.svg';
import highIcon from '../../../assets/icons/biomarkerRanges/high.svg';
import veryHighIcon from '../../../assets/icons/biomarkerRanges/very-high.svg';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  diagnoseReferenceRange: IDiagnoseReferenceRanges | undefined;
  propertyValue: string;
  propertyName: string;
  abbreviation?: string;
  uom: string;
  onSelectDiagnoseResult: () => void;
  height?: string;
  dhp: IDigitalHealthProfile;
  biomarker: IDiagnoseResult;
  small?: boolean;
  isVideoCall?: boolean;
};

const BiomarkerItemSmall: React.FC<Props> = ({
  height,
  onSelectDiagnoseResult,
  diagnoseReferenceRange,
  propertyName,
  abbreviation,
  propertyValue,
  uom,
}) => {
  const { translations } = useTranslation();
  const iconBaseOnRange = (referenceRangeName: string) => {
    if (referenceRangeName === 'Very Low') return veryLowIcon;
    if (referenceRangeName === 'Low') return lowIcon;
    if (referenceRangeName === 'Normal') return normalIcon;
    if (referenceRangeName === 'High') return highIcon;
    return veryHighIcon;
  };

  return (
    <div
      className={classes.container}
      style={{ height: height }}
      onClick={(event) => {
        event.stopPropagation();
        onSelectDiagnoseResult();
      }}
    >
      <img
        className={classes.icon}
        src={iconBaseOnRange(diagnoseReferenceRange?.reference_range_name ?? '')}
        alt="range"
      />
      <div className={classes.row}>
        <div className={classes.nameAndRangeName}>
          <div className={classes.propertyName}>
            {propertyName} {abbreviation && `(${abbreviation})`}
          </div>
          {diagnoseReferenceRange?.reference_range_name && (
            <div style={{ color: `#${diagnoseReferenceRange?.reference_color_code}` }}>
              {translations(
                `biomarkerDetails.${diagnoseReferenceRange?.reference_range_name.toLowerCase()}`
              )}
            </div>
          )}
        </div>
        <div className={classes.valueContainer}>
          <div className={classes.tabletValue}>{parseFloat(propertyValue).toFixed(2)}</div>
          <div className={classes.value}>{parseFloat(propertyValue).toFixed(2)}</div>
          <div className={classes.uom}>{uom}</div>
        </div>
      </div>
    </div>
  );
};

export default BiomarkerItemSmall;
